import { render, staticRenderFns } from "./ProgramsSingleNavAdmin.vue?vue&type=template&id=e6a4496a&"
import script from "./ProgramsSingleNavAdmin.vue?vue&type=script&lang=js&"
export * from "./ProgramsSingleNavAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports